module.exports = __webpack_public_path__ + "img/CS-ECO13_Overview-Rear_1.497ead97.jpg";